import React, { useState, useEffect } from "react";
import { toast } from "../../../../components/toastNotification";
import TextInput from "../../../../components/TextInput";
import { useRecoilState, useRecoilValue } from "recoil";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";

import AddButton from "../../../../components/AddButton";

import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";

import useLobType from "./hooks/useLobType";
import useDeleteLobType from "./hooks/useDeleteLobType";
import useUpdateLobType from "./hooks/useUpdateLobType";
import {
  addStateLobType,
  selectedRowsStateLobType,
  setFilterTextLobType,
} from "./atoms/atoms";
import TableFilters from "../TableFilters";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import { useHistory, useLocation } from "react-router-dom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import EditButton from "../../../../components/EditButton";
import { useQueryClient } from "react-query";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import MaterialProducerCodeConfigTable from "../../../../components/tables/MaterialProducerCodeConfigTable";
import AddLOBTypeForm from "modules/Utilities/LobType/AddLOBTypeForm";

const LobTypeTable = () => {
  //Hooks Call
  const { data, isFetching } = useLobType();
  const { mutateAsync: updateLobType } = useUpdateLobType();
  const BulkDeleteLobTypeType = useDeleteLobType();
  //Atoms Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateLobType);
  const [selectedRows, setSelectedRows] = useRecoilState(
    selectedRowsStateLobType
  );
  const [rowsCount, setRowsCount] = useState(0);
  const [filterText, setFilterText] = useRecoilState(setFilterTextLobType);
  //Local States
  const [editRowId, setEditRowId] = useState(null);
  const [actionEditState, setActionEditState] = useState(false);
  const [editState, setEditState] = useState(false);
  const [, setEmpTypeIsExistState] = useState(false);
  const [empTypeDataIsChange, setEmpTypeDataIsChange] = useState(false);
  const [checkStatus, setCheckStatus] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [hasLobType, setHasLobType] = useState(true);
  const [isBulkSelected, setIsBulkSelected] = useState(false);
  const [disabledButton, setDisabledButton] = useState(false);
  const [, sethideColumn] = useState(false);
  const [LOBTypeFilteredData, setLOBTypeFilteredData] = useState([]);
  const [lobTypeData, setLobTypeData] = useState([]);
  const queryClient = useQueryClient();

  const [, setProdCodeTypeFilteredData] = useState([]);
  const [, setCProgramFilteredData] = useState([]);
  const [, setMgaFilteredData] = useState([]);
  const [, setDisChannelFilteredData] = useState([]);
  const [, setCodeLevelFilteredData] = useState([]);

  //Permission
  const hasEdit = PERMISSIONS.permission_utilities_lobtype_edit;
  const hasAdd = PERMISSIONS.permission_utilities_lobtype_add;
  const hasDelete = PERMISSIONS.permission_utilities_lobtype_delete;
  const userPermissions = useRecoilValue(permissionsSelector);

  const defaultValues = {
    lobname: "",
    lobcode: "",
    createdBy: "",
    createdDate: null,
    modifiedDate: null,
    modifiedBy: "",
    isActive: false,
  };
  const [empNewData, setNewData] = useState([defaultValues]);
  const [editRowData, setEditRowData] = useState();
  useEffect(() => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    setActionAddState(false);
    setActionEditState(false);
    setEditState(false);
    setSelectedRows([]);
    setEditRowId([]);
  }, []);

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows.filter((x) => x.isActive);
    setSelectedRows(forDelete);
    setRowsCount(forDelete.length);
    setIsBulkSelected((prev) => !prev);
  };

  const handleCheckBox = (checked) => {
    setEmpTypeDataIsChange(true);
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? empNewData.map((x) => (x.isActive = true))
      : empNewData.map((x) => (x.isActive = false));
  };

  const handleEditFieldsChange = (SourceType, fieldName, row, inputvalue) => {
    setEmpTypeIsExistState(false);
    setEmpTypeDataIsChange(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "lob") {
      if (fieldName === "LobName") {
        setEmpTypeDataIsChange(true);
        empNewData.map((x) => (x.lobname = inputvalue));
        inputvalue === "" ? setHasLobType(false) : setHasLobType(true);
      }
      if (fieldName === "LobCode") {
        setEmpTypeDataIsChange(true);
        empNewData.map((x) => (x.lobcode = inputvalue));
        inputvalue === "" ? setHasLobType(false) : setHasLobType(true);
      }
    }
  };

  const handleEditButton = (rowData) => {
    setEditRowId(rowData.lobid);
    setEmpTypeDataIsChange(false);
    sethideColumn(true);
    setCheckStatus(rowData.isActive);
    setEditRowData({ ...rowData });
    empNewData.map((x) => (x.isActive = rowData.isActive));
    empNewData.map((x) => (x.lobid = rowData.lobid));
    empNewData.map((x) => (x.lobname = rowData.lobname));
    empNewData.map((x) => (x.lobcode = rowData.lobcode));
    empNewData.map((x) => (x.createdBy = rowData.createdBy));
    empNewData.map((x) => (x.createdDate = rowData.createdDate));
  };

  //Save changes
  const handleSave = (empNewData) => {
    setOpenModalEdit(false);
    if (actionEditState) {
      updateLobType(empNewData, {
        onSuccess: (res) => {
          if (
            editRowData.lobcode === empNewData[0]?.lobcode &&
            editRowData.lobname === empNewData[0]?.lobname &&
            editRowData.isActive === empNewData[0]?.isActive
          ) {
            toast.fire("Saving Failed", "No Changes have been made", "warning");
            setOpenModalEdit(false);
          } else if (empNewData[0]?.lobname === "") {
            toast.fire("Failed", "Please fill LOB Name.", "error");
            setOpenModalEdit(false);
          } else if (empNewData[0]?.lobcode === "") {
            toast.fire("Failed", "Please fill LOB Code.", "error");
            setOpenModalEdit(false);
          } else if (res === "duplicate") {
            toast.fire("Failed", "LOB Type already exists!", "error");
            setOpenModalEdit(false);
          } else {
            setNewData([defaultValues]);
            setEditRowId([]);
            setSelectedRows([]);
            setOpenModalEdit(false);
            setActionEditState(false);
            setEditState(false);
            setDisabledButton(false);
            sethideColumn(false);
            queryClient.invalidateQueries(["GetLobTypes"]);
            toast.fire("Success", "LOB Type updated successfully", "success");
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Update LOB Type", "error");
          queryClient.invalidateQueries(["GetLobTypes"]);
        },
      });
    }
  };
  // end of saving changes

  const handleBulkDelete = () => {
    const ids = selectedRows.map((row) => row.lobid);
    BulkDeleteLobTypeType(ids);
    setSelectedRows([]);
    setOpenModalDelete(false);
    setIsBulkSelected(false);
    setDisabledButton(false);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${rowsCount} ${
      rowsCount > 1 ? "LOB Types" : "LOB Type"
    }?`}</div>
  );

  let location = useLocation();
  const history = useHistory();
  let recordIdFromRecent = "";
  if (location.state != null) {
    recordIdFromRecent = location.state;
  }
  useEffect(() => {
    if (data) {
      setLobTypeData(data);
    }
  }, [data]);
  //For filtered data update
  const [lobTypeId, setLobTypeId] = useState("");
  useEffect(() => {
    if (filterText) {
      setLobTypeData(
        data.filter((x) =>
          x.lobname?.toLowerCase().includes(filterText?.trim().toLowerCase())
        )
      );
    } else if (lobTypeId?.includes(".")) {
      let lobTypeIds = lobTypeId.split(".");
      const lobTypeIdsArr = lobTypeIds.map((id) => Number(id));
      const filteredData = data?.filter((x) => lobTypeIdsArr.includes(x.lobid));

      setLOBTypeFilteredData(filteredData);
    } else if (LOBTypeFilteredData?.length === 1) {
      const filteredData = data?.filter((x) => x.lobid === Number(lobTypeId));

      setLOBTypeFilteredData(filteredData);
    } else {
      setLobTypeData(data);
    }
  }, [filterText, data]);

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          setLOBTypeFilteredData(result);
          setLobTypeId(recordIdFromRecent.recordId);
          history.replace();
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, []);

  const matColumns = [
    {
      title: "LOB Name",
      field: "lobname",
      customSort: (a, b) =>
        a.lobname && b.lobname
          ? a.lobname.trim().localeCompare(b.lobname.trim())
          : a.lobname
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.lobid === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="LOB Name"
              defaultValue={rowData.lobname}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "lob",
                  "LobName",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <span className="text-quinary font-bold uppercase text-sm">
            {rowData.lobname}
          </span>
        );
      },
    },
    {
      title: "LOB Code",
      field: "lobcode",
      align: "left",
      customSort: (a, b) =>
        a.lobcode && b.lobcode
          ? a.lobcode.trim().localeCompare(b.lobcode.trim())
          : a.lobcode
          ? 0
          : -1,
      render: (rowData) => {
        return rowData.lobid === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer">
            <TextInput
              placeholder="LOB Code"
              defaultValue={rowData.lobcode}
              onChange={(inputdata) => {
                handleEditFieldsChange(
                  "lob",
                  "LobCode",
                  rowData,
                  inputdata.target.value
                );
              }}
            />
          </div>
        ) : (
          <span className="w-full mr-8">{rowData.lobcode}</span>
        );
      },
    },
    {
      title: "Created By",
      field: "createdBy",
      hidden: editState,
      align: "left",
      render: (rowData) => {
        return rowData.lobid === editRowId ? (
          <div className="flex items-center space-x-1 cursor-pointer"></div>
        ) : (
          <>{rowData.createdBy}</>
        );
      },
    },
    {
      title: "Created Date",
      field: "createdDate",
      hidden: editState,
      align: "left",
      render: (rowData) => {
        return rowData.lobid === editRowId ? (
          <div className="flex items-start space-x-1 cursor-pointer"></div>
        ) : (
          <>
            {rowData?.createdDate
              ? new Date(rowData.createdDate).toLocaleDateString()
              : ""}
          </>
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
      hidden: editState,
      align: "left",
      render: (rowData) => {
        return rowData.lobid === editRowId ? (
          <></>
        ) : (
          <div>
            <div className="flex items-center space-x-1 cursor-pointer">
              {rowData.modifiedBy}
            </div>
          </div>
        );
      },
    },
    {
      title: "Modified Date",
      field: "modifiedDate",
      hidden: editState,
      align: "left",
      render: (rowData) => {
        return rowData.lobid === editRowId ? (
          <></>
        ) : (
          <div>
            <div className="flex items-center space-x-1 cursor-pointer">
              {rowData.modifiedDate
                ? new Date(rowData.modifiedDate).toLocaleDateString()
                : ""}
            </div>
          </div>
        );
      },
    },
    {
      title: "Status",
      field: "isActive",
      align: "left",
      render: (rowData) => {
        return rowData.lobid === editRowId ? (
          <div className="flex justify-start place-items-center  space-x-1 cursor-pointer">
            <input
              type="checkbox"
              className="flex items-center space-x-1 cursor-pointer"
              defaultChecked={rowData.isActive}
              onClick={(e) => {
                handleCheckBox(e.target.checked);
              }}
            />
            <label className="cursor-pointer text-green-600" name="Status">
              {checkStatus ? "Uncheck to Deactivate" : "Check to Activate"}
            </label>
          </div>
        ) : (
          <div>
            <div className="font-sans mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Action/s",
      align: "center",
      render: (rowData) => {
        return rowData.lobid === editRowId ? (
          <div className="flex place-content-center gap-2 ">
            <SaveButton
              className={`flex shadow-md lg:text-center font-semibold text-white  gap-x-1 rounded-full  bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
            ${
              !hasLobType || !empTypeDataIsChange ? "opacity-50" : "opactiy-100"
            }`}
              disabled={!hasLobType || !empTypeDataIsChange}
              onClick={() => {
                setOpenModalEdit(true);
              }}
            />
            <CancelButton
              className="flex lg:text-center shadow-md font-semibold text-white ml-1 gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-octonary focus:ring-opacity-70"
              onClick={() => {
                setActionEditState(false);
                setEditState(false);
                setEditRowId([]);
                setEmpTypeDataIsChange(false);
                setEmpTypeIsExistState(false);
                setDisabledButton(false);
              }}
            />
          </div>
        ) : (
          <div className="space-x-1 flex items-center place-content-center mr-5">
            {userPermissions.includes(hasEdit) && (
              <EditButton
                disabled={disabledButton || selectedRows.length > 0}
                className={
                  disabledButton || selectedRows.length > 0
                    ? "opacity-50 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary "
                    : "opacity-100 rounded-full  items-center bg-quaternary  text-white hover:bg-hquaternary"
                }
                onClick={() => {
                  setDisabledButton(true);
                  setActionEditState(true);
                  setEditState(true);
                  handleEditButton(rowData);
                  sethideColumn(true);
                }}
              />
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="bg-white animate-fade-in-down p-4">
      {!actionAddState && (
        <div className="">
          <div className="bg-white w-full ">
            <div className="flex flex-row justify-between items-center">
              <div className="">
                <TableFilters
                  setLOBTypeFilteredData={setLOBTypeFilteredData}
                  setCProgramFilteredData={setCProgramFilteredData}
                  setProdCodeTypeFilteredData={setProdCodeTypeFilteredData}
                  setMgaFilteredData={setMgaFilteredData}
                  setCodeLevelFilteredData={setCodeLevelFilteredData}
                  setDisChannelFilteredData={setDisChannelFilteredData}
                  setFilterText={setFilterText}
                  placeholder="LOB Name"
                  disabledButton={disabledButton || selectedRows.length > 0}
                />
              </div>
              <div className="">
                {userPermissions.includes(hasAdd) && (
                  <AddButton
                    buttonText="New LOB Type"
                    className={
                      selectedRows.length > 0 || actionEditState
                        ? "opacity-50 float-right"
                        : "opacity-100 float-right"
                    }
                    onClick={() => setActionAddState(!actionAddState)}
                    disabled={disabledButton || selectedRows.length > 0}
                  />
                )}
              </div>
            </div>
            <div>
              <div className="text-secondary italic text-xs3 py-2">
                {!actionAddState &&
                !actionEditState &&
                userPermissions.includes(hasDelete) ? (
                  <div>
                    <p className="font-bold italic inline-block mr-1">
                      {" "}
                      Note:{" "}
                    </p>
                    Tick the box to deactivate some data.
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="overflow-y-auto ">
              <MaterialProducerCodeConfigTable
                columns={matColumns}
                data={
                  LOBTypeFilteredData?.length > 0
                    ? LOBTypeFilteredData
                      ? LOBTypeFilteredData
                      : lobTypeData
                    : lobTypeData
                }
                options={{
                  toolbar: false,
                  showTitle: false,
                }}
                selection={
                  !actionAddState &&
                  !actionEditState &&
                  userPermissions.includes(hasDelete)
                }
                setOpenModal={setOpenModalDelete}
                onSelectionChange={handleSelectedRowsChange}
                selectedRows={selectedRows}
                isDeactivate={true}
                isLoading={isFetching}
              />
            </div>
          </div>

          <ConfirmBoxModal
            ModalTitle="Update LOB Type"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => setOpenModalEdit(false)}
            onClickFunction={() => {
              handleSave(empNewData);
            }}
          />
          <ConfirmBoxDelete
            ModalTitle="Deactivate LOB Type"
            qConfirmation={deleteMessage}
            isOpen={openModalDelete}
            onClose={() => setOpenModalDelete(false)}
            onClickFunction={
              isBulkSelected ? handleBulkDelete : handleBulkDelete
            }
          />
        </div>
      )}
      {actionAddState && (
        <div className="">
          <AddLOBTypeForm />
        </div>
      )}
    </div>
  );
};

export default LobTypeTable;
